import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container } from '../../../../ui/gridSystem';
import {
  CustomInput,
  CustomSelect,
  NoResult,
  Text,
} from '../../../../ui/atoms';
import {
  ActivityCard,
  FiltersWrapper,
  Legend,
  SortingWrapper,
  CompletionWrapper,
  SectionsContainer,
} from './style';
import SortBy from '../../../../ui/atoms/SortBy';
import { withMediaQueries } from '../../../hoc/withMediaQueries';
import { COURSE_ACTIVITIES_GET } from '../../../redux/actions/statistics';
import CustomTooltip from '../../../../ui/atoms/CustomTooltip';
import Inline from '../../../../ui/atoms/Inline';
import {
  COURSE_ACTIVITY_TYPES,
  getSortingOptions,
} from '../../../../utils/labels';

const Activities = ({ sections, getCourseActivities }) => {
  const { course_id } = useParams();
  // filters
  const [selectedFilters, setSelectedFilters] = useState();
  const [searchValue, setSearchValue] = useState();

  useEffect(() => {
    getCourseActivities(selectedFilters, course_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, search_text: searchValue });
  };

  return (
    <Container className="pt-0">
      <Text type="h2" mb={34}>
        Report attività
      </Text>
      <FiltersWrapper>
        <CustomInput
          size={410}
          placeholder="Cosa vuoi cercare?..."
          isSearch
          value=""
          icon="search-sm"
          isClearable
          onChange={(v) => setSearchValue(v)}
          onClickIcon={onClickSearch}
          onKeyPress={(event) => {
            if (event.key === 'Enter') onClickSearch();
          }}
        />
        <CustomSelect
          size="s"
          placeholder="Tipologia attività"
          options={COURSE_ACTIVITY_TYPES}
          isClearable
          onChange={(v) =>
            setSelectedFilters({
              ...selectedFilters,
              type: v?.value,
            })
          }
          selected={
            COURSE_ACTIVITY_TYPES.find(
              (s) => s.value === selectedFilters?.type
            ) ?? null
          }
        />
      </FiltersWrapper>
      {sections?.length > 0 ? (
        <SectionsContainer>
          {sections.map((section, si) => (
            <div key={`section-${si}`}>
              {section?.section_title && (
                <Text type="h2.5" mb={8}>
                  {section?.section_title}
                </Text>
              )}
              <SortingWrapper>
                <SortBy
                  options={getSortingOptions([
                    'created_asc',
                    'created_desc',
                    'type_asc',
                    'type_desc',
                    'rate_asc',
                    'rate_desc',
                  ])}
                  onChange={(v) => {
                    setSelectedFilters({
                      ...selectedFilters,
                      sort_by: v?.value,
                    });
                  }}
                />
              </SortingWrapper>
              <Legend>
                <Text type="statistics-heading">Codice</Text>
                <Text type="statistics-heading">Nome attività</Text>
                <Text type="statistics-heading">Tipologia</Text>
                <Text type="statistics-heading">Assegnazioni</Text>
                <Text type="statistics-heading">Completamenti</Text>
                <Text type="statistics-heading">Accesso</Text>
                <Text type="statistics-heading">Registrazione</Text>
                <Text type="statistics-heading">Tempo medio di permanenza</Text>
                <CompletionWrapper>
                  <Text type="statistics-heading">Punteggio medio quiz</Text>
                  <CustomTooltip
                    type="primary"
                    title="Punteggio Medio Quiz"
                    tooltipKey="quiz_average_score"
                  />
                </CompletionWrapper>
              </Legend>
              {(section?.activities || []).map((activity, ai) => (
                <ActivityCard key={`activity-${ai}`}>
                  <Text type="b5">{activity?.code || '-'}</Text>
                  <CustomTooltip
                    type="primary"
                    title={activity.title}
                    className="ellipsis"
                  >
                    <Text type="h3" className="ellipsis">
                      {activity.title}
                    </Text>
                  </CustomTooltip>
                  <Text type="b4">{activity?.type || '-'}</Text>
                  <Text type="b2">{activity?.count_visible || 0}</Text>
                  <Inline alignItems="baseline">
                    <Text type="b2">{activity?.count_completed ?? 0}</Text>
                    <Text type="b4">/{activity?.count_visible ?? 0}</Text>
                  </Inline>
                  {/* fields empty by defult (related to events) */}
                  <Text type="b4">-</Text>
                  <Text type="b4">-</Text>
                  <Text type="b4">{activity?.average_duration || '-'}</Text>
                  <Text type="b4">
                    {activity?.average_score
                      ? `${activity?.average_score}%`
                      : '-'}
                  </Text>
                </ActivityCard>
              ))}
            </div>
          ))}
        </SectionsContainer>
      ) : (
        <NoResult />
      )}
    </Container>
  );
};

Activities.propTypes = {
  // HOC: state
  sections: PropTypes.array,
  //HOC: dispatch
  getCourseActivities: PropTypes.func,
};

export default connect(
  (state) => {
    const {
      activities: { list: sections },
    } = state.statistics.course;
    return {
      sections,
    };
  },
  (dispatch) => ({
    getCourseActivities: (filters, course_id) =>
      dispatch({ type: COURSE_ACTIVITIES_GET._REQUEST, filters, course_id }),
  })
)(withMediaQueries(Activities));
